exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.footer[data-v-2d0f4d52]{padding:10px;color:#fff;background-color:#000;text-align:center\n}", ""]);

// exports
